import { DialogTextPropsMixin } from '@/vue/modals/Dialogs/mixins/DialogTextPropsMixin';
import { DialogTitlePropsMixin } from '@/vue/modals/Dialogs/mixins/DialogTitlePropsMixin';

export const DialogPropsMixin = {
    mixins: [
        DialogTextPropsMixin,
        DialogTitlePropsMixin,
    ],

    props: {
        // Modal properties
        modalSize: {
            type: String,
            default: null,
        },

        // Cancel button properties
        cancelLabel: {
            type: String,
            default: 'CANCEL',
        },
        cancelCustomText: {
            type: String,
            default: null,
        },
        cancelColor: {
            type: String,
            default: 'default',
        },

        // OK button properties
        okLabel: {
            type: String,
            default: 'OK',
        },
        okCustomText: {
            type: String,
            default: null,
        },
        okColor: {
            type: String,
            default: 'primary',
        },

    },
};
